import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useErrorToast } from './queryUtils';
import { getSlackSearchStatus, disconnectSlackSearch } from '../services/api/slackSearch';

const SLACK_SEARCH_KEY = ['slack-search-connection'];

/** ProfilePage Slack-search block status (Phase 109, Plan 109-08). */
export function useSlackSearchStatus() {
  return useQuery({
    queryKey: SLACK_SEARCH_KEY,
    queryFn: getSlackSearchStatus,
  });
}

/**
 * Disconnects the Slack search grant only — invalidates SLACK_SEARCH_KEY
 * alone. The Slack grant is a separate credential from the Claude/Monk PAT
 * connection (`['bot-connection']`, see `useBotConnection.ts`), so a Slack
 * disconnect must not invalidate or otherwise change that status.
 *
 * There is deliberately no `useConnectSlackSearch` mutation here: connecting
 * is a full-page navigation (`window.location.href = slackSearchConnectUrl()`
 * in `MonkBotSection.tsx`), not a fetch. A `fetch` following the backend's
 * 302 would land Slack's OAuth consent page in a response body instead of
 * the browser — never add a connect mutation to this file.
 */
export function useDisconnectSlackSearch() {
  const queryClient = useQueryClient();
  const onError = useErrorToast();
  return useMutation({
    mutationFn: () => disconnectSlackSearch(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SLACK_SEARCH_KEY });
    },
    onError: (err) => onError(err, "Couldn't disconnect Slack search"),
  });
}
